var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partner-banner w-full"},[_c('div',{staticClass:"partner-banner-bg block"},[_c('img',{staticClass:"w-full",attrs:{"src":_vm.details.image}}),_c('img',{staticClass:"partner-banner-bg-icon relative",attrs:{"src":_vm.details.icon}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }